<template>
  <div class="explore-sales md-layout md-alignment-center-center">

    <div class="container-header explore-sales__header">
      <searcher
        class="sales-overview__searcher"
        @search-input="loadFilteredSales"
      />
    </div>

    <md-progress-spinner v-if="sales.length === 0 && !isLoaded"
                         class="sales-loader"
                         md-mode="indeterminate"
                         :md-diameter="100"
                         :md-stroke="10">
    </md-progress-spinner>

    <template v-if="sales.length">
      <div class="md-layout md-gutter md-size-100 md-alignment-top-left sales-overview__inner">
        <router-link v-for="sale in sales"
                    :key="sale.id"
                    :to="{name: 'sales.sale-details', params: { id: sale.id }}"
                    tag="div"
                    class="md-layout-item sales-overview__card-wrapper md-size-33 md-xlarge-size-25 md-medium-size-50 md-small-size-100">
          <sale-card class="sales-overview__card block" :sale="sale"/>
        </router-link>
      </div>
    </template>
    <template v-if="sales.length === 0 && isLoaded">
      <not-available-card icon='trending_up' :title="i18n.com_no_sales_found()" :descr="i18n.com_no_sales_found_desc()"/>
    </template>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { vuexTypes } from '@vuex/types'
  import { i18n } from '@js/i18n'
  import SaleCard from '../sale_card/Sales.SaleCard'
  import Searcher from './Sales.Searcher'
  import NotAvailableCard from '../../common/NotAvailableCard'
  import FormMixin from '@com/mixins/form.mixin'
  import { saleSortTypes, saleStates } from '@const'

  const initialState = saleStates.actual
  const initialSort = saleSortTypes.created

  export default {
    name: 'TokensExplore',
    mixins: [FormMixin],
    components: { SaleCard, Searcher, NotAvailableCard },
    data: _ => ({
      isLoaded: false,
      filters: {
        openOnly: initialState.openOnly,
        upcoming: initialState.upcoming,
        sortBy: initialSort.num,
        order: initialSort.order,
        baseAsset: ''
      },
      i18n
    }),
    async created () {
      await this.loadFilteredSales()
      this.isLoaded = true
    },
    computed: {
      ...mapGetters([
        vuexTypes.sales
      ])
    },
    methods: {
      ...mapActions({
        loadSalesByName: vuexTypes.GET_SALES_BY_NAME
      }),
      loadFilteredSales (filters, type = null) {
        if (filters) {
          this.filters.openOnly = filters.state.openOnly
          this.filters.upcoming = filters.state.upcoming
          this.filters.sortBy = filters.sortBy.num
          this.filters.order = filters.sortBy.order
          this.filters.baseAsset = filters.token
          this.filters.name = filters.name
          this.filters.type = type
        } else {
          this.filters.openOnly = false
          this.filters.upcoming = false
        }
        return this.loadSalesByName(this.filters)
      },
      loadMore () {
        this.disable()
        this.next()
        this.enable()
      }
    },
    watch: {
    }
  }
</script>

<style lang="scss" scoped>
  @import '~scss/variables';
  @import '~scss/mixins';

  .explore-sales__header {
    padding: 0 12px;
    background-color: $default-white;

    @include respond-to(large) {
      flex-direction: column;
      align-items: flex-start;
      padding: 0 8px;
    }
  }

  .sales-overview__inner {
    width: 100%;
    @include respond-to(medium-tablet) {
      justify-content: center;
    }
  }

  .sales-overview__card-wrapper {
    display: block;
    height: auto;
    max-height: 550px;
    margin-bottom: 1.5rem;
    font-size: initial;
    text-align: initial;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/sales/overview/Sales.Explore.vue